var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityHeroImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1078.219,
    height: 288.597,
    viewBox: "0 0 1078.219 288.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(-20709.955 -16666.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    transform: "translate(21578.98 16669.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M452.28,661.2l2.415-71.315-5.045-88.1c18.722-10.426,42.294-15.929,68.966-15.929s50.242,5.5,68.963,15.929l-4.01,88.1,4.854,71.315Z",
    transform: "translate(-414.019 -375.688)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M465.869,517.216l21.389,52.823,22.492-52.823-4.106-47.2H469.981Z",
    transform: "translate(-383.212 -405.767)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M469,494.025l12.316,30.417,12.951-30.417Z",
    transform: "translate(-377.268 -360.169)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M504.4,491.349c18.307,5.752,33.671,116.14,33.671,156.312,0,1.015,0,2.053-.012,3.105H505.1l-.145-.954c-2.8-17.751-11.517-73.843-11.517-73.843S493.19,516.574,504.4,491.349Z",
    transform: "translate(-330.838 -365.252)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M504.4,491.349c13.616,4.28,30.383,61.668,35.631,109.77l-43.4,4.778c-2.505-16.1-3.184-29.928-3.184-29.928S493.19,516.574,504.4,491.349Z",
    transform: "translate(-330.838 -365.252)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M471.708,491.349c-18.3,5.752-33.671,116.14-33.671,156.312,0,1.015,0,2.053.012,3.105H471l.148-.954c2.8-17.751,11.514-73.843,11.514-73.843S482.92,516.574,471.708,491.349Z",
    transform: "translate(-436.077 -365.252)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M472.992,491.349c-13.616,4.28-30.38,61.668-35.631,109.77l43.4,4.778c2.505-16.1,3.184-29.928,3.184-29.928S484.2,516.574,472.992,491.349Z",
    transform: "translate(-437.361 -365.252)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M493.24,449.125c7.657.38,30.728,1.783,30.372,31.714s-5.178,39.621-8.927,44c-4.8,5.6-12.462,11.737-31.12,13.717-10.844-.873-12.482-7.405-15.732-13.862-2.592-5.152-7.692-15.524-6.533-45.437S485.571,449.116,493.24,449.125Z",
    transform: "translate(-392.212 -445.454)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M474.154,464.1c-1.467-.026-2.743,1.412-2.85,3.213s.992,3.279,2.456,3.305a3.169,3.169,0,0,0,2.853-3.213C476.72,465.6,475.621,464.124,474.154,464.1Z",
    transform: "translate(-372.903 -417.014)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M465.663,464.1c1.467.049,2.668,1.548,2.685,3.352s-1.157,3.224-2.624,3.178-2.667-1.551-2.685-3.352S464.2,464.049,465.663,464.1Z",
    transform: "translate(-388.587 -417.014)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M465.2,461.711a4.616,4.616,0,0,1,2.746,3.679c.525,5.926-1.7,17.194-1.554,19.383.2,2.984,4.79,2.8,4.79,2.8",
    transform: "translate(-384.478 -421.548)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M478.624,473.771s-5.257,3.737-13.9-.493",
    transform: "translate(-385.381 -399.577)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M480.558,462.157c-1.8-.7-6.994-.5-10.1.188",
    transform: "translate(-374.487 -421.526)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M461.838,462.424c1.754-.812,6.947-.948,10.087-.464",
    transform: "translate(-390.868 -421.606)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M517.585,473.412c2.685,1.7-3.236,25.008,9.211,23.636,8.113-12.27,9.635-27.739-.841-34.031-1.986-10.951-12.705-15.553-26.379-15.132-7.889.246-16.628,7.388-25.588,7.455-14,.1-18.319,8.527-13.355,16.272,2.157,3.364,9.5,4.03,12.688,2.885,4.448-1.6,16.24,6.338,24.7,6.022C507.652,480.159,510.983,475.044,517.585,473.412Z",
    transform: "translate(-396.922 -447.859)",
    fill: "#c3bab1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M488.975,452.074c2.83,9.542-3.868,22.021-14.689,24.016",
    transform: "translate(-367.222 -439.853)",
    fill: "none",
    stroke: "#c3bab1",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M482.086,466.941a6.428,6.428,0,0,1,4.593-3.636c2.36-.432,6.59.87,6.411,7.521s-5.868,12.227-9.356,11.345S482.086,466.941,482.086,466.941Z",
    transform: "translate(-353.33 -418.662)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M482.635,467.53c.023-.832,3.352-4.6,6.051-1.908",
    transform: "translate(-351.365 -415.937)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M506.084,469.929c-1.792,8.2-4.2,12.244-6.269,14.668-4.8,5.6-12.462,11.737-31.12,13.72",
    transform: "translate(-377.842 -405.938)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 35.65,
    height: 21.253,
    transform: "translate(53.831 174.527)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 29.996,
    height: 17.882,
    transform: "translate(54.958 175.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 5.769,
    height: 17.883,
    transform: "translate(67.072 169.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 7.931,
    height: 9.454,
    transform: "translate(72.355 179.196)",
    fill: "#2f2e6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 13.061,
    height: 2.561,
    transform: "translate(56.614 179.196)",
    fill: "#2f2e6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 13.061,
    height: 2.562,
    transform: "translate(56.614 183.833)",
    fill: "#2f2e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M452.331,581.252s4.222-54.481.594-76.928",
    transform: "translate(-408.926 -340.607)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M496.413,601.192s-6.663-72.8,3.766-107.45",
    transform: "translate(-329.178 -360.707)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872",
    transform: "translate(21108.768 16666.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M353.407,659.511l-1.522-68.734,11.409-88.1c-18.722-10.426-42.3-15.93-68.966-15.93s-50.244,5.5-68.966,15.93l11.409,88.1-2.12,68.734Z",
    transform: "translate(-205.083 -371.198)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M238.787,490.672l31.626,60.83,30.9-60.7-11.9-4.19H252.236Z",
    transform: "translate(-179.583 -371.457)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M249.761,547.92l30.1-22.89-3.665-10.1,11.152-7.408-3.837-19.1",
    transform: "translate(-158.739 -367.999)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M274.813,547.92l-30.472-22.89,3.5-10.1-11.27-7.408,3.529-19.1",
    transform: "translate(-183.791 -367.999)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869",
    transform: "translate(101.459 105.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868",
    transform: "translate(0 45.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M260.193,536.1l.911.229.774.2-.217.768-.429,1.511-.209.737-.734-.191-.594-.16h0l-.293-.072v0c-2.32-.586-3.65-.919-5.071-3a7.448,7.448,0,0,1-.963-3.836c-.267-7.919,7.434-24.364,12.41-27.629l.612-.4.438.589.945,1.264.507.681-.719.446s-.812.548-2.954,4.025c-3.662,5.944-8.159,13.462-8.1,20.7a4.75,4.75,0,0,0,.458,2.424C257.711,535.475,258.615,535.7,260.193,536.1Z",
    transform: "translate(-253.361 -489.113)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M257.5,520.04c-1.746-.464-2.847-1.937-2.462-3.3s2.114-2.085,3.859-1.621,2.847,1.937,2.462,3.294S259.247,520.5,257.5,520.04Z",
    transform: "translate(-250.316 -468.717)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M262.817,536.823l-.9-.27-.765-.232-.209.768-.409,1.516-.2.739.728.212.591.174h0l.287.087v0c2.29.7,3.6,1.093,5.9.038a7.437,7.437,0,0,0,2.8-2.792c4.308-6.649,6.176-24.715,3.592-30.073l-.316-.661-.678.275-1.464.6-.783.322.386.751s.415.89.461,4.976c.078,6.979.058,15.738-3.714,21.917a4.79,4.79,0,0,1-1.641,1.841C265.267,537.563,264.374,537.293,262.817,536.823Z",
    transform: "translate(-240.113 -485.158)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M261.981,521.405c1.737.5,3.442-.194,3.81-1.557s-.739-2.876-2.473-3.381-3.439.194-3.807,1.557S260.25,520.9,261.981,521.405Z",
    transform: "translate(-241.814 -466.206)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M279.438,501.334a66.378,66.378,0,0,1,2.207,6.541c.6,2.125,1.058,4.126,1.409,5.973.189.986.351,1.977.5,2.957q.209,1.418.342,2.638a21.015,21.015,0,0,1,.3,2.5c.046.739.043,1.287.038,1.609l-.041,1.551-1.545-.032-1.308-.026-1.261.078-1.542.1-.1-1.548c-.032-.484-.073-1.029-.125-1.658V522c-.044-.51-.1-1.108-.177-1.8-.052-.261-.122-.554-.209-.875s-.188-.647-.293-.945a13,13,0,0,0-1.3-2.279,7.108,7.108,0,0,0-3.859-2.888,7.2,7.2,0,0,0-4.842.568,13.707,13.707,0,0,0-2.36,1.383c-.258.215-.5.435-.739.655s-.461.458-.681.7q-.579.752-1.073,1.429c-.363.493-.69.951-.983,1.366l-.867,1.235-1.255-.829-1.044-.687-1.131-.615-1.4-.763.8-1.383c.174-.3.473-.8.876-1.371a22.5,22.5,0,0,1,1.6-2.021q.77-.992,1.667-2.073c.638-.769,1.3-1.543,1.989-2.3,1.29-1.432,2.74-2.934,4.361-4.456s3.4-3.059,5.355-4.555l.615-.47.739.2,4.3,1.174.751.206.287.725Zm-7.138,6a14.4,14.4,0,0,1,1.711.339,14.044,14.044,0,0,1,1.708.574l-.128-.415h0c-.261-.844-.545-1.7-.855-2.563-.533.432-1.177.974-1.844,1.551Z",
    transform: "translate(-248.167 -499.026)",
    fill: "#f6aa32",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M275.672,531.549c6.295-16.782,4.378-47.171-19.342-48.345",
    transform: "translate(-247.721 -483.204)",
    fill: "none",
    stroke: "#f6aa32",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.417,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M243.513,556.145c-10.36-12.7-22.723-69.836,17.373-72.846",
    transform: "translate(-190.137 -377.744)",
    fill: "none",
    stroke: "#f6aa32",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.417,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(46.87 174.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M240.015,529.153a11.8,11.8,0,0,1-3.361-16.7,12.668,12.668,0,0,1,17.24-3.256,11.8,11.8,0,0,1,3.36,16.7A12.67,12.67,0,0,1,240.015,529.153Z",
    transform: "translate(-234.533 -507.141)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M239.618,523.223a7.882,7.882,0,0,1-2.244-11.157,8.461,8.461,0,0,1,11.514-2.175,7.884,7.884,0,0,1,2.247,11.157,8.462,8.462,0,0,1-11.517,2.174Zm1.583-2.279a5.569,5.569,0,0,0,7.582-1.429,5.19,5.19,0,0,0-1.479-7.344,5.568,5.568,0,0,0-7.579,1.432A5.186,5.186,0,0,0,241.2,520.944Z",
    transform: "translate(-231.831 -504.524)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M285.463,518.106c0,31.181-43.883,31.181-43.883,0l4.109-47.2h35.66Z",
    transform: "translate(-174.278 -401.278)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M269.734,449.156c-7.666.186-30.763,1-31.166,30.934s5.361,40.905,9,45.382,7.42,8.524,14.886,10.676c1.949,2.169,4.007,3,7.281,3.468,3.276-.47,5.335-1.3,7.283-3.468,7.466-2.151,11.244-6.2,14.883-10.676s9.4-15.451,9-45.382S277.4,449.341,269.734,449.156Z",
    transform: "translate(-180.037 -442.596)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M259.575,466.77c.731-1.893,1.627-3.213,3.972-3.706s6.608.7,6.6,7.356-5.555,12.372-9.066,11.58S259.239,468.544,259.575,466.77Z",
    transform: "translate(-141.408 -416.365)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M251.714,470.809c-2.725,1.635,2.467,25.472-9.942,23.787-6.5-8.733-7.782-30.607,4.468-36.31,3.494-11.719,14.358-11.238,26.283-11.389,28.4-.362,38.3,25.4,31.369,47.148-9.281-.354-6.82-11.612-10.963-14.025-4.094-2.383-12.152,1.325-20.6.8C262.706,480.218,258.276,472.613,251.714,470.809Z",
    transform: "translate(-183.125 -446.894)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M246.626,466.816a6.434,6.434,0,0,0-4.5-3.752c-2.349-.493-6.611.7-6.6,7.356s5.555,12.372,9.064,11.58S246.626,466.816,246.626,466.816Z",
    transform: "translate(-185.776 -416.365)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M245.915,463.965a2.985,2.985,0,0,1,2.609,3.094c.058,1.7-1.015,3.065-2.395,3.053a2.981,2.981,0,0,1-2.609-3.091C243.462,465.322,244.532,463.953,245.915,463.965Z",
    transform: "translate(-170.597 -414.468)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M242.388,467.357c0-.832-3.233-4.688-6-2.062",
    transform: "translate(-184.138 -413.656)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M259.877,467.357c0-.832,3.23-4.688,6-2.062",
    transform: "translate(-139.524 -413.656)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M255.418,463.965a2.985,2.985,0,0,0-2.609,3.094c-.058,1.7,1.012,3.065,2.395,3.053a2.979,2.979,0,0,0,2.609-3.091C257.871,465.322,256.8,463.953,255.418,463.965Z",
    transform: "translate(-152.955 -414.468)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M249.4,464.224c1.351,3.239-.27,12.691-1.081,15.257s2.972,2.16,2.972,2.16",
    transform: "translate(-161.701 -413.976)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M246.937,473.347s4.86,3.645,13.1-.136",
    transform: "translate(-164.103 -396.905)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 8.974,
    y2: 0.093,
    transform: "translate(98.632 44.215)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 8.974,
    y2: 0.093,
    transform: "translate(70.892 44.215)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M245.653,450.112c-6.074,7.881-4.317,21.937,5.059,27.693",
    transform: "translate(-173.277 -440.781)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M243.34,490.585A24.956,24.956,0,0,0,253.349,496c1.951,2.169,4.01,3,7.283,3.468,3.273-.47,5.332-1.3,7.281-3.468a25.144,25.144,0,0,0,9.116-4.656,36.23,36.23,0,0,0,12.25-21.053",
    transform: "translate(-170.935 -402.45)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M259.8,506.393l3.035,21.808-6.343,12.462-6.53-12.56,2.668-21.709-6.515-6.567,5.074-7.512,4.945,4.123,4.879-4.123,5.2,7.512Z",
    transform: "translate(-165.662 -360.619)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M249.551,507.161l14.315,7.238,11.576-26.036-4.735-1.666Z",
    transform: "translate(-159.138 -371.291)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M267.87,506.852l-14.2,7.237-13.732-25.576,4.708-1.666Z",
    transform: "translate(-177.392 -371.005)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 0.334,
    y2: 109.456,
    transform: "translate(90.171 178.857)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M233.341,634.429c31.6.139,75.368-17.229,97.471-27l-44.854-11.073-3.993-10.31c-10.093,1.815-19.873,3.613-27.985,5.178-1.641-22.337-2.586-48.1-2.963-60.283-.293-9.533.444-39.583-12.369-38.693-25.935,25.466-25.129,116.894-8.1,142.186Z",
    transform: "translate(-218.368 -360.776)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M253.63,529.9c-3.294-1.415-18.8-9.026-23.454-11.146.467,8.806,1.029,17.913,1.7,26.35a71.665,71.665,0,0,1,8.562,1.34c2.366.539,10.737.983,12.207.209a20.923,20.923,0,0,0,3.839-3.384Z",
    transform: "translate(-195.94 -310.389)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M237.879,521.679,236.133,542.6l8.182,1.573,5.124-19.546Z",
    transform: "translate(-184.625 -304.843)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M245.715,527.814c-7.739,4.8-21.1,5.547-23.216,14.4-1.656,6.915,15.99-9.707,20.85-4.514,4.987,5.326-3.439,14.187-5.158,21.282",
    transform: "translate(-210.728 -293.19)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M351.474,635.2l-.073-.023c-43.944.377-113.62-34.161-113.62-34.161l4.915-21.473s53.1,10.247,85.939,17.023c-.046-23.552-1.7-52.547-1.3-65.617.293-9.533-.444-39.583,12.369-38.693,28.446,15.666,27.072,119.234,11.789,142.913v.009h-.006Z",
    transform: "translate(-181.494 -360.776)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(126.146 208.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M282.49,531.769a4.609,4.609,0,0,0,2.841-1.879c.334-.554-10.18-6.767-10.18-6.767S279.9,530.92,282.49,531.769Z",
    transform: "translate(-236.658 -510.527)",
    fill: "#edba68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M264.221,530.609c3.792-1.653,23.8-11.65,24.686-11.821s14.341,2.006,14.341,2.006l12.607,10.946s-5.019.064-6.651-.58-5.315-4.268-5.315-4.268l-6.973-.334,5.213,3.972s13.511,12.778,14.32,13.169-3.74,1.232-6.042.217-8.44-5.535-8.44-5.535,6.88,7.623,7.617,8.577c-.583.7-2.583,1-4.077.38l.354.713a11.372,11.372,0,0,1-6.338.319,11.491,11.491,0,0,1-4.973-2.508s-6.727-.014-7.855-.162a23.935,23.935,0,0,0-4.2.441v-.078c-6.315-1.3-13.361-2.728-20.624-4.187Z",
    transform: "translate(-261.875 -518.779)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M272.816,522.962a40.551,40.551,0,0,1,5.039,4.059,36.24,36.24,0,0,1,4.019,4.657",
    transform: "translate(-241.093 -510.833)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M288.118,533.771c-2.551-1.459-7.289-5.008-8.565-5.732s-8.6-2.116-8.6-2.116",
    transform: "translate(-244.632 -505.211)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M272.116,521.392l1.543,17.4c-3.178-.644-6.448-1.3-9.762-1.966L260.57,524.4Z",
    transform: "translate(-138.208 -305.388)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M292.44,538.042l-.058-17.22s-22.018,3.72-46.478,8.031C258.638,531.338,276.1,534.768,292.44,538.042Z",
    transform: "translate(-166.065 -306.471)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M270.522,528.939s16.628,9.264,17.455,23.271c.484,8.205-13.688-11.293-13.688-11.293",
    transform: "translate(-119.305 -291.053)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874",
    transform: "translate(21293.492 16667.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873",
    transform: "translate(253.843 147.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M370.184,531.56c.441-2.108,4.752-15.924,5.123-17.31s5.886-5.355,6.91-5.947,5.483-3.854,6.616-5.776a13.307,13.307,0,0,1,5.228-4.288c1.371.435.9,5.868-1.163,8.037s-3.978,3.326-4.926,4.558a7.875,7.875,0,0,0-1.157,3.4l3.2.983s7.371-2.114,8.356-2.1,6.013-2.6,6.013-2.6,2.05-4.894,3.268-4.819c.609-.209,1.163-.435,1.775.539.357-2.827,2.725-5.4,4.529-5.616.478.209,1.076,1.4,1.076,1.4.273-.577,2.172-2.024,2.865-1.838a1.3,1.3,0,0,1,.87.887c1.247-2,2.54-2.978,4.048-2.575a23.262,23.262,0,0,1-1.844,6.434c-1.148,2.911-4.639,9.029-4.639,9.029l-2.207,5.471s-7.454,5.677-8.449,6.153-2.4,4.8-4.03,5.355-17.408,6.356-18.733,7.608a12.567,12.567,0,0,0-2.505,4.28C380.045,543.724,370.161,531.183,370.184,531.56Z",
    transform: "translate(-370.184 -498.24)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 5.538,
    y2: 15.86,
    transform: "translate(43.841 3.292)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M391.259,499.722l-3.524,11.33-5.036,8.811",
    transform: "translate(-346.411 -495.424)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M376,521.013c3.334-1.876,4.378-2.085,5.628-2.085s5.628.209,5.628.209l3.752-4.378s2.085-7.292,2.291-8.336,1.67-4.793,3.129-5.628",
    transform: "translate(-359.129 -493.387)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M374.338,507.966,390.132,521.8l-4.792,6.817-17.266-10.5Z",
    transform: "translate(-120.347 -332.165)",
    fill: "#8fb2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M348.327,492.54c18.243,12.439,39.882,56.142,53.437,102.327l.145.9c15.663-24.034,39.224-50.888,40.207-52.26,5.709,4.422,12.862,14.639,19.058,19.145-6.471,18.359-36.9,72.617-51.735,79.43-26.385-3.578-35.884-17.339-47.406-32.7C357.095,602.794,302.754,512.364,348.327,492.54Z",
    transform: "translate(-192.204 -361.465)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M306.355,660.534l-1.812-70.079-11.409-88.1c13.581-7.565,29.714-12.537,47.731-14.7a179.131,179.131,0,0,1,21.236-1.232c9.693,0,13.216-1.07,21.723,1.548,15.15,4.665,21.389,6.161,34.993,16.6,4.575,36.7,2.09,60.532-.345,87.024-2.111,22.955.791,45.977-.8,68.94Z",
    transform: "translate(-262.693 -373.496)",
    fill: "#c4bab1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M306.032,488.6c25.237,38.014,46.527,34.5,63.872,1.83l-12.218-4.19H320.5C315.638,487.228,310.41,487.245,306.032,488.6Z",
    transform: "translate(-238.194 -373.434)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M352.516,519.65l-19.068,16.536L309.5,516.594l-.062-45.755,39.831,5.612Z",
    transform: "translate(-231.72 -402.686)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M336.508,506.3l-13.641,7.238-15.037-25.3,4.581-1.666Z",
    transform: "translate(-234.779 -372.801)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M338.131,450.177c-7.66.38-30.728,1.78-30.375,31.711s5.181,39.621,8.93,44c4.8,5.6,12.459,11.737,31.117,13.717,10.844-.873,12.485-7.405,15.735-13.862,2.592-5.149,7.689-15.523,6.529-45.434S345.8,450.168,338.131,450.177Z",
    transform: "translate(-234.925 -441.932)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M313.166,503.472c-2.639-14.233-18.522-40.2-.183-41.827,1.514-13.665,15.179-14.88,17.939-14.146,9.472,2.514,18.525,5.932,24.306,6.225,5.97.3,11.143-1.035,14.523-1.783,4.746-1.047,8.005,4.013,3.52,7.063,2.1-.351,8.292-3.128,10.992,3.181,3.236,7.553-15.025,15.379-25.895,15.019-18.449-.612-23.135-3.731-35.808-7.025-2.639.438,7.73,19.267-.191,22.346S313.606,503.472,313.166,503.472Z",
    transform: "translate(-241.546 -447.333)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M357.164,459.915a51.957,51.957,0,0,1-40.879-3.459",
    transform: "translate(-218.719 -430.005)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M319.77,465.149c1.464-.026,2.743,1.412,2.85,3.213s-.992,3.279-2.459,3.305-2.743-1.412-2.853-3.213S318.3,465.175,319.77,465.149Z",
    transform: "translate(-216.788 -413.493)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M328.25,465.15c-1.467.049-2.667,1.551-2.685,3.352s1.154,3.227,2.621,3.178,2.67-1.548,2.688-3.352S329.717,465.1,328.25,465.15Z",
    transform: "translate(-201.092 -413.494)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M329.152,462.762a4.614,4.614,0,0,0-2.749,3.682c-.525,5.924,1.7,17.191,1.557,19.38-.2,2.984-4.79,2.8-4.79,2.8",
    transform: "translate(-205.641 -418.027)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M320.915,474.825s5.257,3.737,13.894-.5",
    transform: "translate(-209.924 -396.056)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M316.491,463.21c1.8-.7,6.993-.5,10.093.186",
    transform: "translate(-218.327 -418.005)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M335.205,463.478c-1.754-.812-6.95-.951-10.087-.467",
    transform: "translate(-201.941 -418.085)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M339.725,465.7c-2.076-.3-17.423-2.752-25.234-.159-1.693,4.059,2.07,12.01,3.479,12.856s14.486,1.015,17.026.591c2.54-.084,3.856-9.133,4.233-10.319a10.913,10.913,0,0,0,.273-1.084c1.98-.452,2.34-.6,4.312-.015a11.291,11.291,0,0,0,.275,1.1c.377,1.186,1.693,10.235,4.233,10.319,2.54.423,8.147.252,9.56-.591s5.173-8.8,3.479-12.856c-7.666-2.546-15.129-.229-17.64.139-2.085-.438-1.908-.336-4,.02Zm6.158,1.125c1.461-.209,6.744-2.282,13.2-.139,1.38,3.314-1.69,9.806-2.844,10.5s-4.361.832-6.437.484c-2.073-.067-3.149-7.457-3.456-8.426a15.13,15.13,0,0,1-.461-2.415Zm-8.449,0a15.12,15.12,0,0,1-.461,2.415c-.307.968-1.383,8.359-3.456,8.426-2.076.348-12.752.209-13.906-.484s-4.224-7.182-2.841-10.5C323.224,464.54,335.976,466.613,337.435,466.822Z",
    transform: "translate(-222.941 -414.992)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M355.5,497.5c-7.791,0-14.17.71-18.774,5.668s-22.172-5.381-22.767-31.543-7.344-7.423-6.634,3.2.708,23.024,7.437,34.361,20.612,19.693,33.72,19.693c15.358,0,21.172-16.278,21.447-36.968-1.545,2.679-3.381,12.569-4.819,10.064-1.888-3.3-6.167-4.709-9.612-4.48Zm-11.267,6.953c1.235-3.558,17.643-3.41,18.707.133s-4.958,10.273-9.919,9.562S342.373,509.81,344.234,504.457Z",
    transform: "translate(-235.833 -426.419)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M315.878,467.993a6.415,6.415,0,0,0-4.593-3.636c-2.357-.435-6.588.867-6.411,7.518s5.868,12.227,9.356,11.345S315.878,467.993,315.878,467.993Z",
    transform: "translate(-240.403 -415.14)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M311.763,468.582c-.02-.832-3.352-4.6-6.051-1.911",
    transform: "translate(-238.802 -412.415)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M331.085,486.739s1.049,80.573,1.3,172.784h-32.4l4.552-70.08-11.409-88.1S305.712,492.3,331.085,486.739Z",
    transform: "translate(-262.693 -372.484)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M313.076,491.775c-16.414,8.771-25.741,87.8-30.441,158.182H317.33c2.438-24.341,4.77-48.771,6.7-73.562C324.033,576.4,324.288,517,313.076,491.775Z",
    transform: "translate(-282.635 -362.918)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M285.317,543.407c22.4-10.922,27.9-6.245,23.662-1.87-3.827,3.955-17.713,15.013-23.1,23.108m8.5,0a40.4,40.4,0,0,1,6.176-3.456",
    transform: "translate(-277.541 -277.607)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M317.877,574.868l-18.165-43.452,7.048-9.439L299.628,507.1l10.581-19.633",
    transform: "translate(-250.358 -371.095)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M328.6,487.844s4.375,82.324,8.875,169.58h20.276l-5.81-64.948s4.827-80.489,0-91.756A59.592,59.592,0,0,0,328.6,487.844Z",
    transform: "translate(-195.335 -370.385)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M331.619,576.719l10.054-45.009L333.743,523,339.4,507.5l-8.62-18.515",
    transform: "translate(-191.188 -368.21)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M317.721,505.982l13.641,7.238,12.605-24.814-4.58-1.666Z",
    transform: "translate(-215.992 -372.483)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M355.958,528.1c9.09,4.175,16.457,22.105,13.508,29.719s-6.877-8.844-9.823-14.492-5.894-.983-4.422,7.368",
    transform: "translate(-145.505 -293.915)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(20919.277 16676.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M178.966,562.119l.084-24.1c13.9,0,21.644,1.65,35.541,1.65a94.121,94.121,0,0,1,9.507,22.45Z",
    transform: "translate(-97.329 -283.794)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M212.429,562.119l1.751-24.1H175.1a103.215,103.215,0,0,0-11.224,24.1Z",
    transform: "translate(-125.999 -283.794)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M210.6,637.6c13.662,0,28.049-2.015,41.709-2.015-3.474-20.928-4.375-39.125-3.685-60.682,2.862-23.494,10.36-45.263,13.222-68.757-10.757-10.557-30-19.5-50.056-19.5s-39.3,8.942-50.056,19.5c2.862,23.494,10.363,45.263,13.221,68.757.69,21.557-.122,39.754-3.592,60.682C185.019,635.589,196.939,637.6,210.6,637.6Z",
    transform: "translate(-130.066 -381.365)",
    fill: "#fccca6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M256.12,610.513,230.138,613.8c-3.778-17.568-27.49-63.721-35.791-82.13-3.92-8.7-10.389-32.222,1.195-37.768,5.042-2.415,10.255-1.464,15.121,1.432C231.182,512.248,254.78,587.309,256.12,610.513Z",
    transform: "translate(-78.32 -370.194)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M265.336,562.119a96.572,96.572,0,0,0-9.98-24.1H171.968a103.216,103.216,0,0,0-11.224,24.1Z",
    transform: "translate(-131.941 -283.794)",
    fill: "#4247ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M181.876,493.376c-16.683,14.683-21.18,76.986-27.675,119.6-1.5,9.829-2.47,21.621-3.082,33.944h26.008c1.685-10.873,3.036-19.568,3.694-23.729,2.8-17.75,13.3-77.56,13.3-77.56S193.085,518.6,181.876,493.376Z",
    transform: "translate(-150.223 -368.591)",
    fill: "#f2d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M182.463,493.376c-16.683,14.683-21.18,76.986-27.675,119.6-1.5,9.873-2.83,21.662-3.978,33.944h27.469c1.34-10.861,2.47-19.557,3.129-23.729,2.8-17.75,13.3-77.56,13.3-77.56S193.672,518.6,182.463,493.376Z",
    transform: "translate(-150.81 -368.591)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M190.8,488.148s15.512,80.613,10.551,168.7H159.773c6.08-16.695,13.459-21.949,15-35,1.812-15.419,1.273-56.91,2.093-61.6s-14.7-53.257-14.7-53.257S167.715,495.939,190.8,488.148Z",
    transform: "translate(-133.785 -378.521)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M154.119,537.652c6.135-.792,18.406-10.021,18.406-2.375s-16.634,13.691-18.406,20.186,8.71-.394,13.062-.594",
    transform: "translate(-144.902 -294.723)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M192.888,566.691l-23.8-35.286,9.224-11.531-12.969-8.069,3.985-22.009",
    transform: "translate(-123.205 -375.39)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M193.821,487.764s-15.834,80.523-10.212,169.812h42.616c-6.272-19.681-14.607-24.721-16.251-38.682-1.812-15.416-1.27-56.907-2.093-61.6s14.7-53.26,14.7-53.26S208.344,490.321,193.821,487.764Z",
    transform: "translate(-90.804 -379.251)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M182.013,564.837l23.8-35.286-9.224-11.531,12.969-8.069-3.823-21.117",
    transform: "translate(-91.541 -377.219)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 75.047,
    height: 97.996,
    rx: 1.743,
    transform: "matrix(0.969, -0.247, 0.247, 0.969, 51.173, 169.272)",
    fill: "#8fb2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M205.156,533.251c-.98-.792-3.517.014-4.842-1.276-2.723-2.653-5.776-5.779-7.483-6.938l-4.538,2.734c-2.9-.064-5.747-.441-5.747-.441-2.525-1.589-5.564-3.946-7.385-5.176a47.339,47.339,0,0,0-2.891-4.3,13.291,13.291,0,0,0-2.178-3.967,16.808,16.808,0,0,0-.342,2.92c-.058,1.557,1.592,5.338,1.592,5.338a6.08,6.08,0,0,0-1.731,3.238l2.763,4.544,1.89,1.017-1.87.218c.678,3.659-.1,3.378,3.082,5.039l-1.174.919c.829,3.83.534,2.888,4.564,3.764,0,0,3.433,4.737,15.88,4.743,1.235.5,9.1,2.134,11.192,2.981Z",
    transform: "translate(-115.097 -329.634)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M184.2,524.187a29.142,29.142,0,0,0-2.209-3.491c-.278-.638-3.2-4.317-3.447-4.958-.362.383-2.81,2.769-2.754,2.894a36.445,36.445,0,0,1,1.763,5.454Z",
    transform: "translate(-103.361 -326.116)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M180.628,519.465c-2.8-2.955-4.975-5.689-4.975-5.689a3.508,3.508,0,0,0-.821,3.245,28.751,28.751,0,0,0,3.042,5.338Z",
    transform: "translate(-105.443 -329.842)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M275.676,572.7c-43.639-5.149-94.861-27.722-94.861-27.722l-.438-25.315c27.385,9.7,74.6,12.091,91,29.841Z",
    transform: "translate(-94.649 -318.66)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M170.18,516.734l1.98,4.066,9.205,6.736",
    transform: "translate(-114.019 -324.223)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M199.366,526.974c14.836-5.958,32.187-6.129,22.149,3.056",
    transform: "translate(-58.581 -312.756)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876",
    transform: "translate(32.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M183.474,462.95c6.04-12.363,31.566-15.277,42.523-10.31,21.108,9.565,26.382,35.915,37.22,42.981,12.152,7.927,6.869,23.506,0,26.939s-5.8,6.854-10.287,13c-7.289,9.968-19.606,14.486-30.064,3.111-4.456-4.851-15.318-4.662-15.318-4.662-5.291-2.2-9.559,5.019-25.359,5.547-9.962.331-19.9-12.772-15.411-22.279,7.979-16.9-3.128-20.716-4.4-31.517C160.719,471.651,168.533,461.758,183.474,462.95Z",
    transform: "translate(-162.158 -450.338)",
    fill: "#c3bab1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M180.132,451.871c42.918,2.1,37.588,34.857,52,39.143",
    transform: "translate(-128.018 -447.428)",
    fill: "none",
    stroke: "#c3bab1",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M166.6,472.862c-5.393,7-4.384,19.47,3.94,24.579",
    transform: "translate(-160.073 -407.556)",
    fill: "none",
    stroke: "#c3bab1",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M202.682,518.388c0,17.542-29.5,17.542-29.5,0V490.026c9.835,0,19.67-16.3,29.5-16.3Z",
    transform: "translate(-141.223 -405.906)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M195.5,456.144c-7.179.157-28.809.844-29.186,26.066s3.389,33.6,5.465,38.238c2.383,5.318,6.7,12.308,14.341,12.413,16.46.232,22.894-6.817,27.252-11.638,3.407-3.769,8.806-13.018,8.429-38.238S202.679,456.3,195.5,456.144Z",
    transform: "translate(-154.314 -439.311)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M184.629,471.776c.647-1.679,1.441-2.85,3.523-3.288s5.868.623,5.86,6.527-4.932,10.983-8.049,10.279S184.33,473.351,184.629,471.776Z",
    transform: "translate(-120.642 -416.03)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M177.51,474.222c-5.874-.525-14.584,10.017-10.29,20.371-4.8-22.648,3.207-39.531,28.409-39.853s34.213,20.4,30.154,39.778c-10.928-.838-8.017-9.983-11.693-12.123-3.633-2.117-10.786,1.177-18.287.707C187.267,482.572,183.332,475.819,177.51,474.222Z",
    transform: "translate(-155.058 -441.984)",
    fill: "#c3bab1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M186.621,473.851a1.831,1.831,0,1,0,1.83,1.832A1.833,1.833,0,0,0,186.621,473.851Z",
    transform: "translate(-119.173 -405.678)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M170.056,468.44a2.927,2.927,0,0,1,2.56,3.036c.061,1.664-.992,3.007-2.349,3a2.928,2.928,0,0,1-2.56-3.036C167.65,469.771,168.7,468.431,170.056,468.44Z",
    transform: "translate(-151.622 -415.956)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M184.895,472.3c0-.739,2.87-4.161,5.326-1.83",
    transform: "translate(-118.971 -413.626)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M178.253,468.44a2.928,2.928,0,0,0-2.56,3.036c-.058,1.664.992,3.007,2.349,3a2.928,2.928,0,0,0,2.56-3.036C180.659,469.771,179.607,468.431,178.253,468.44Z",
    transform: "translate(-136.455 -415.956)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M170.555,466.473c5.764,5.842,2.694,17.779,1.9,20.3s2.914,2.12,2.914,2.12",
    transform: "translate(-146.209 -419.692)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M169.93,476.348s4.77,3.575,12.853-.133",
    transform: "translate(-147.396 -401.187)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M171.53,478s1.766,1.328,4.764-.049",
    transform: "translate(-144.357 -397.896)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M175.277,466.964s3.268-2.45,8.806.09",
    transform: "translate(-137.24 -420.777)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M175.824,466.964s-3.268-2.45-8.806.09",
    transform: "translate(-152.928 -420.777)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M174.742,492.894c7.539-.525,17.255-4.21,24.816-15.555",
    transform: "translate(-138.256 -399.053)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M182.477,468.627c-1.754-.246-10.029-2.256-16.623-.13-1.429,3.326,1.748,9.838,2.937,10.531s7.55.832,9.693.484c2.143-.07,3.256-7.484,3.572-8.452a8.289,8.289,0,0,0,.232-.89,7.046,7.046,0,0,1,4.19-.011,8.516,8.516,0,0,0,.232.9c.316.968,1.429,8.382,3.572,8.452,2.143.348,13.178.209,14.37-.484s4.367-7.205,2.937-10.531c-6.472-2.085-19.072-.189-21.192.116a7.973,7.973,0,0,0-3.92.015Zm5.747.919c1.232-.168,11.995-1.867,17.44-.113,1.168,2.717-1.427,8.034-2.4,8.6s-9.986.681-11.734.4c-1.751-.055-2.659-6.109-2.917-6.9a12.024,12.024,0,0,1-.391-1.98Zm-7.681,0a12.21,12.21,0,0,1-.388,1.98c-.261.794-1.168,6.848-2.92,6.9-1.748.284-6.083.168-7.057-.4s-3.563-5.883-2.4-8.6C173.225,467.679,179.311,469.378,180.543,469.546Z",
    transform: "translate(-155.826 -417.682)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882",
    transform: "translate(20709.955 16676.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879",
    transform: "translate(91.324 161.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M125.273,608.285c36.9-13.526,80.12-68.433,88.83-79.871l-.235-8.73-1.635-5.97s-83.173,58.035-97.949,68.262Z",
    transform: "translate(-114.284 -491.316)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878",
    transform: "translate(90.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M145.442,536.459c.2-1.731,2.679-13.175,2.879-14.317s4.355-4.738,5.138-5.289,4.138-3.5,4.912-5.132a10.746,10.746,0,0,1,3.9-3.833c1.137.252,1.151,4.662-.357,6.559s-2.963,2.966-3.639,4.027a6.378,6.378,0,0,0-.687,2.824l2.653.56s5.781-2.235,6.579-2.293,4.657-2.528,4.657-2.528,1.3-4.091,2.285-4.114c.475-.214.907-.438,1.47.3.084-2.3,1.8-4.552,3.242-4.854.4.136.968,1.053.968,1.053.177-.487,1.6-1.789,2.175-1.688a1.055,1.055,0,0,1,.765.65c.861-1.7,1.832-2.581,3.076-2.366a18.982,18.982,0,0,1-1.021,5.318c-.716,2.427-3.088,7.608-3.088,7.608l-1.38,4.567s-5.6,5.114-6.364,5.57-1.586,4.042-2.859,4.6-13.569,6.379-14.546,7.484a10.145,10.145,0,0,0-1.708,3.63C154.265,545.546,145.4,536.155,145.442,536.459Z",
    transform: "translate(-145.442 -505.989)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 3.316,
    y2: 13.178,
    transform: "translate(34.3 2.709)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M160.746,507.316l-2.021,9.382L155.3,524.16",
    transform: "translate(-126.708 -503.469)",
    fill: "#ffedde",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M149.99,526.133c2.551-1.751,3.375-1.995,4.384-2.085s4.549-.238,4.549-.238l2.705-3.8s1.151-6.028,1.244-6.883,1-3.984,2.114-4.761",
    transform: "translate(-136.803 -501.47)",
    fill: "#ffedde",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M160.574,510.061c8.255,6.318,26.814,26.681,28.91,34.4,3.079,11.357.89,19.081-1.166,30.58-2.957,16.559-2.328,46.728-2.537,58.259-.122,6.7-.177,14.9-.177,24.32h-72.08c2.975-8.376,6.225-16.411,8.672-24.216,2.1-6.7,5.271-16.483,4.529-23.424s-19.423-67.635-17.837-80.645,7.849-36.542,14.41-41.6C140.321,502.27,150.006,512,160.574,510.061Z",
    transform: "translate(-33.39 -379.096)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M82.787,521.693c12.528,37.252,66.246,81.936,77.447,90.953h8.733l6.011-1.473s-55.768-84.71-65.594-99.755Z",
    transform: "translate(-82.787 -334.117)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M174.212,492.356c-21.308-6.144-79.378,53.707-91.425,66.383l13.665,22.1c14.233-10.972,73.051-43.341,78.824-47.864C185.158,525.241,187.535,496.195,174.212,492.356Z",
    transform: "translate(-82.787 -371.163)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M158.037,492.356c-13.5-3.894-44.767,18.725-66.734,39.038l26.539,31.1c19.293-11.311,38.038-27,41.259-29.519C168.979,525.241,171.36,496.195,158.037,492.356Z",
    transform: "translate(-66.611 -371.163)",
    fill: "#fff",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M166.805,459.868c-11.563-12.5-33.051-11.989-45.707-3.1-16.376,11.5-18.942,32.326-10.774,51.257-1.943,24.526,19.319,40.174,29.713,27.434,4.164-5.106,5.686-1.826,5.686-1.826,5.152-2.511,4.8,4.744,20.6,4.335,9.962-.255,19.107-13.923,14.065-23.149-4.833-8.84-4.309-19.89-1.171-24.721,5.19-3.256,7.9-4.671,9.006-9.771C191.227,466.447,181.65,457.795,166.805,459.868Z",
    transform: "translate(-39.038 -450.268)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M113.777,523.305c4.923-14,11.975-27.2,2.56-53.335,13.314,7.466,20.354,23.715,33.671,31.181-8.327,14.909.249,40.343,1.679,44.547C142.441,547.629,122.177,533.442,113.777,523.305Z",
    transform: "translate(-23.923 -412.846)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M159.742,457.891c4.532,1.766,10.5,12.407,11.006,23.1.261,5.515-3.14,6.985-2.873,11.511.362,1.595,2.279,4.627,4.538,7.97,2.114,3.123,3.929,5.552,3.862,6.231-.177,1.78-3,3.758-4.917,3.978a57.153,57.153,0,0,0-1.279,8.237c-.333,4.491-.046,9.423-.647,11.038-1.18,3.166-2.433,3.636-8.5,4.358s-24.837-.945-35.214-15.065-16.075-36.423-11.206-47.136C123.519,452.292,141.02,450.59,159.742,457.891Z",
    transform: "translate(-25.883 -443.325)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M120.84,478.742c4.036,3.445,9.838,6.683,19.571,8.3",
    transform: "translate(-10.507 -396.184)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M131.832,466.72c1.47-.113,2.47,1.27,2.238,3.085s-1.615,3.381-3.082,3.494-2.473-1.27-2.238-3.085S130.362,466.833,131.832,466.72Z",
    transform: "translate(4.453 -419.031)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M130.051,475.21c.38.31,3.131,1.954,8.463.763",
    transform: "translate(6.988 -402.893)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M136.714,465.789s-3.407-2.253-8.785.612",
    transform: "translate(2.958 -422.385)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M166.218,476.687c4.28-8.217,11.038-7.066,12.778-2.108,3.932-11.578-14.523-25.866-43.01-20.116-29.5,5.953-33.689,62.025-22.735,78.517,17.011,18.832,17.82,5.286,21.685-24.883.577-9.754-.38-17.948,1.363-17.872,1.832.081,1.835,5.126,9.261,4.036,6.988-1.026,4.4-4.636,7.611-9.116C156.795,480.091,163.061,482.75,166.218,476.687Z",
    transform: "translate(-35.43 -444.797)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880",
    transform: "translate(93.205 44.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M125.771,469.112a6.326,6.326,0,0,0-4.761-3.36c-2.375-.293-6.535,1.258-6.037,7.889s6.448,11.867,9.887,10.78c1.89-.6,4.343-4.114,4.039-8.107C128.651,473.047,125.771,469.112,125.771,469.112Z",
    transform: "translate(-114.933 -465.718)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M121.877,469.808c-.061-.829-3.566-4.4-6.132-1.548",
    transform: "translate(-113.39 -462.955)",
    fill: "#ffedde",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.425,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M135.9,476.546s-1.688,1.429-4.758.232",
    transform: "translate(9.059 -400.355)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "translate(77.925 255.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M127.8,549.114a4.016,4.016,0,0,0,2.369-1.757c.264-.5-9.125-5.373-9.125-5.373S125.516,548.5,127.8,549.114Z",
    transform: "translate(-88.049 -531.623)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M115.647,549.652c3.2-1.609,15.747-11.029,16.5-11.221s12.5,1.058,12.5,1.058l11.421,8.866s-4.338.293-5.779-.186-4.8-3.442-4.8-3.442l-6.045.043,4.7,3.186s12.291,10.412,13.01,10.713-3.175,1.241-5.216.473a68.779,68.779,0,0,1-7.562-4.387s5,4.97,6.582,6.617H109.663Z",
    transform: "translate(-109.663 -538.411)",
    fill: "#ffedde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M119.015,541.956a35.375,35.375,0,0,1,4.552,3.271,31.674,31.674,0,0,1,3.7,3.842",
    transform: "translate(-91.899 -531.678)",
    fill: "#ffedde",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M131,549.609c-2.262-1.322-5.039-3.143-5.924-3.584-1.137-.568-7.536-1.421-7.536-1.421",
    transform: "translate(-94.693 -526.646)",
    fill: "#ffedde",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M125.3,469.533a26.215,26.215,0,1,1-24.619,27.719A26.214,26.214,0,0,1,125.3,469.533Z",
    transform: "translate(-48.895 -413.765)",
    fill: "#2f2e6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M113.774,487.923l26.907,30.6,11.079.528-2.637,8.442,25.543,8.262",
    transform: "translate(-23.93 -378.745)",
    fill: "none",
    stroke: "#2f2e6b",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.567,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityHeroImg);
export default __webpack_public_path__ + "static/media/community-hero-img.15acc03a4e680724df84dc8c469d70ba.svg";
export { ForwardRef as ReactComponent };